/* eslint no-unused-vars: 0 */
/* eslint react/no-did-mount-set-state: 0 */
import React      from 'react';
import Rebase     from 're-base';
import { base }   from '../config';
import PropTypes  from 'prop-types';
import List       from './VisitsList';
import Blessings  from './BlessingsList';
import Map        from './Map';
import { Link }  from 'react-router-dom';

const getDisplayName = (user) => {
  return user.first + ' ' + user.last.charAt(0) + '.';
};

class UserPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      list: [],
      username: props.match.params.username,
      panel: props.match.params.panel
    };
  }
  componentDidMount() {
    base.syncState('visits_2017_08_02', {
      context: this,
      asArray: true,
      state: 'list',
      queries: {
        orderByChild: 'username',
        equalTo: this.state.username
      },
      then: () => {
        this.setState({
          loading: false
        });
      }
    });
  }
  handleRemoveItem(index) {
    this.setState({
      list: this.state.list
    });
  }
  toggleMap() {
    this.setState({
      panel: 'map'
    });
  }
  render() {
    if (this.state.loading === true) {
      return (
        <h1></h1>
      );
    }
    if (this.state.panel === 'map') {
      return (
        <div>
          <div className="panel panel-list">
            <Map visits={ this.state.list }/>
          </div>
        </div>
      );
    }
    return (
      <div>
        <a href="#map" onClick={ this.toggleMap.bind(this) } >Map</a>
        <div className="panel panel-list">
          <div className="panel-header">
            <h1>{ this.state.username }s Blessings</h1>
          </div>
          <Blessings items={ this.state.list } />
          <div className="panel-header">
            <h1>{ this.state.username } Feastin</h1>
          </div>
          <List items={ (this.state.list).reverse() } remove={this.handleRemoveItem.bind(this)} />
        </div>
        <div>
          {this.props.children}
        </div>
      </div>
    );
  }
}

UserPage.propTypes = {
  children: PropTypes.object,
  actions: PropTypes.object,
  username: PropTypes.string,
  match: PropTypes.object,
  map: PropTypes.bool
};

UserPage.contextTypes = {
  user: PropTypes.object
};

export default UserPage;



// WEBPACK FOOTER //
// ./client/components/UserPage.js